import { css } from '@emotion/core';
import { rgba, globalTokens, tokens } from '@domain-group/fe-brary';
export var mobileCTA = /*#__PURE__*/css("display:flex;justify-content:center;gap:16px;padding:12px;box-shadow:0 -1px 4px 0 ", rgba(globalTokens.colors.black, 0.15), ";background:", tokens.colors.neutral.surface.default, ";");
var _ref = {
  name: "1afjgxj",
  styles: "padding:8px 12px;"
};
export var callButton = hasApplyOnline => /*#__PURE__*/css("flex:unset;min-height:unset;padding:8px 26px;", hasApplyOnline && _ref);
export var applyButton = {
  name: "dvx08",
  styles: "margin-left:26px;"
};